module.exports = __webpack_public_path__ + "static/about-img1-c75f9907e0e4844decd87a37a9b84a87.png";